export class Changelog {
  application: string;
  content: string;

  constructor(application: string, content: string) {
    this.application = application;
    this.content = content;
  }
}
